import theme from '../../base';

const badge = {
  default: {
    bg: theme.colors.neutrals.gray700,
    border: theme.colors.neutrals.gray700,
    foreground: theme.colors.neutrals.white,
  },
  error: {
    bg: theme.colors.reds.red100,
    border: theme.colors.reds.red900,
    foreground: theme.colors.reds.red900,
  },
  info: {
    bg: theme.colors.blues.blue100,
    border: theme.colors.blues.blue900,
    foreground: theme.colors.blues.blue900,
  },
  primary: {
    bg: theme.colors.primary.primary500,
    border: theme.colors.primary.primary500,
    foreground: theme.colors.neutrals.white,
  },
  spotlight: {
    bg: theme.colors.neutrals.gray800,
    border: theme.colors.neutrals.gray800,
    foreground: theme.colors.neutrals.white,
  },
  success: {
    bg: theme.colors.greens.green100,
    border: theme.colors.greens.green900,
    foreground: theme.colors.greens.green900,
  },
  warning: {
    bg: theme.colors.yellows.yellow100,
    border: theme.colors.yellows.yellow900,
    foreground: theme.colors.yellows.yellow900,
  },
};

export default badge;
